module.exports = __webpack_public_path__ + "static/media/icon-x-16.a7b7fe10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-x-16.svg
// module id = 257
// module chunks = 0